// extracted by mini-css-extract-plugin
export default {"container":"registered-manufacturer-cell_container__JwSK8","pill":"registered-manufacturer-cell_pill__lByCl","pillStatic":"registered-manufacturer-cell_pillStatic__XNvAg"};